// 锚点导航
document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('.anchor-tabs-ul .anchor-tab-item');
    var timeout;
    var ulContainer = document.querySelector('.anchor-tabs-ul');
    var selectContainer = document.querySelector('.anchor-tabs-select');
    
    if (!tabs.length) return;
    
    // 检查是否原本就有 anchor-tabs-select 类
    var hasOriginalSelectClass = ulContainer.classList.contains('anchor-tabs-select');
    
    // 检查屏幕宽度，小于1280px时强制启用select模式（仅当原本没有时）
    function checkScreenSize() {
        if (!hasOriginalSelectClass) {
            if (window.innerWidth < 1280) {
                if (!ulContainer.classList.contains('anchor-tabs-select')) {
                    ulContainer.classList.add('anchor-tabs-select');
                    // 重新初始化
                    initSelectMode();
                }
            } else {
                if (ulContainer.classList.contains('anchor-tabs-select')) {
                    ulContainer.classList.remove('anchor-tabs-select');
                    // 重新初始化
                    initNormalMode();
                }
            }
        }
    }
    
    // 监听窗口大小变化
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(checkScreenSize, 100);
    });
    
    // 初始检查
    checkScreenSize();
    
    // 获取所有需要监听的section ID
    var sectionIds = [];
    for (var i = 0; i < tabs.length; i++) {
        var href = tabs[i].querySelector('a').href.split('#')[1];
        if (href && document.getElementById(href)) {
            sectionIds.push(href);
        }
    }
    
    // 初始化select模式
    function initSelectMode() {
        var currentSelectContainer = document.querySelector('.anchor-tabs-select');
        if (!currentSelectContainer) return;
        
        var currentTabs = document.querySelectorAll('.anchor-tabs-ul .anchor-tab-item');
        var firstTab = currentTabs[0]; // 预留的显示区域
        var otherTabs = Array.from(currentTabs).slice(1); // 真正的选项
        const isMobile = window.innerWidth < 768;
        const remHeight = isMobile ? 3.25 : 2.75;
        const firstRemHeight = isMobile ? 1 : 0.5;
        const baseExpression = isMobile ? '100% + 1rem' : '100% + 1.25rem';

        // 动态设置每个选项的位置 1
        for (var i = 0; i < otherTabs.length; i++) {
            var tab = otherTabs[i];
            var offset = i === 0 ? 0 : (i * remHeight + firstRemHeight);
            var topValue = offset === 0
                ? `calc(${baseExpression})`
                : `calc(${baseExpression} + ${offset}rem)`;
            tab.style.top = topValue;
        }
        
        // 初始化：设置第一个选项为默认显示
        if (otherTabs.length > 0) {
            firstTab.querySelector('a').textContent = otherTabs[0].querySelector('a').textContent;
        }
        
        // 点击第一个标签展开/收起下拉框
        firstTab.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            currentSelectContainer.classList.toggle('open');
        };
        
        // 点击其他选项
        for (var i = 0; i < otherTabs.length; i++) {
            otherTabs[i].onclick = function(e) {
                e.preventDefault();
                var id = this.querySelector('a').href.split('#')[1];
                var target = document.getElementById(id);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
                // 更新第一个标签的文本
                firstTab.querySelector('a').textContent = this.querySelector('a').textContent;
                // 关闭下拉框
                currentSelectContainer.classList.remove('open');
            };
        }
        
        // 点击外部关闭下拉框
        document.addEventListener('click', function(e) {
            if (!currentSelectContainer.contains(e.target)) {
                currentSelectContainer.classList.remove('open');
            }
        });
    }
    
    // 初始化普通模式
    function initNormalMode() {
        var currentTabs = document.querySelectorAll('.anchor-tabs-ul .anchor-tab-item');
        
        // 普通模式 - 点击滚动
        for (var i = 0; i < currentTabs.length; i++) {
            currentTabs[i].onclick = function(e) {
                e.preventDefault();
                var id = this.querySelector('a').href.split('#')[1];
                var target = document.getElementById(id);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            };
        }
    }
    
    // 根据当前状态初始化
    if (ulContainer.classList.contains('anchor-tabs-select')) {
        initSelectMode();
    } else {
        initNormalMode();
    }
    
    // 只有在非下拉框模式下才监听滚动
    function initScrollListener() {
        if (!ulContainer.classList.contains('anchor-tabs-select')) {
            // 滚动监听激活
            function checkActive() {
                var current = '';
                
                for (var i = 0; i < sectionIds.length; i++) {
                    var section = document.getElementById(sectionIds[i]);
                    if (section) {
                        var rect = section.getBoundingClientRect();
                        if (rect.top <= 100 && rect.bottom > 100) {
                            current = sectionIds[i];
                            break;
                        }
                    }
                }
                
                // 普通模式 - 添加激活状态
                var currentTabs = document.querySelectorAll('.anchor-tabs-ul .anchor-tab-item');
                for (var j = 0; j < currentTabs.length; j++) {
                    var href = currentTabs[j].querySelector('a').href.split('#')[1];
                    if (href === current) {
                        currentTabs[j].classList.add('active', 'vi-title', 'md:!tw-opacity-100');
                    } else {
                        currentTabs[j].classList.remove('active', 'vi-title', 'md:!tw-opacity-100');
                    }
                }
            }
            
            window.onscroll = function() {
                clearTimeout(timeout);
                timeout = setTimeout(checkActive, 10);
            };
            
            checkActive();
        }
    }
    
    // 初始化滚动监听
    initScrollListener();
    
    // 更新checkScreenSize函数，包含滚动监听
    function updateCheckScreenSize() {
        if (!hasOriginalSelectClass) {
            if (window.innerWidth < 1280) {
                if (!ulContainer.classList.contains('anchor-tabs-select')) {
                    ulContainer.classList.add('anchor-tabs-select');
                    // 重新初始化
                    initSelectMode();
                    initScrollListener();
                }
            } else {
                if (ulContainer.classList.contains('anchor-tabs-select')) {
                    ulContainer.classList.remove('anchor-tabs-select');
                    // 重新初始化
                    initNormalMode();
                    initScrollListener();
                }
            }
        }
    }
    
    // 更新窗口大小监听
    window.removeEventListener('resize', checkScreenSize);
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(updateCheckScreenSize, 100);
    });
});